// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__rwE_r","title":"AfterFrontImage_title__3G--U"};